/**
 * HelpButton — floating launcher button. Mirrors Bug Tracker's HelpButton.vue.
 * Bound to a single help system; toggles its drawer.
 */
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HelpSystemBase } from '../../help-system-base';

@Component({
  selector: 'app-help-button',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button type="button" class="help-fab"
            [class.help-fab--gallery]="system.systemId === 'gallery'"
            [class.help-fab--hidden]="system.isOpen$ | async"
            (click)="system.toggle()"
            title="Help (press ?)" aria-label="Open help">
      <span class="help-fab__mark">?</span>
    </button>
  `,
  styles: [`
    .help-fab {
      position: fixed; right: 22px; bottom: 22px; z-index: 10700;
      width: 52px; height: 52px; border-radius: 50%; border: none; cursor: pointer;
      background: #178d9b; color: #fff; box-shadow: 0 6px 18px rgba(23,141,155,0.45);
      transition: transform 0.12s ease, opacity 0.12s ease;
    }
    .help-fab--gallery { background: #178d9b; box-shadow: 0 6px 18px rgba(23,141,155,0.45); }
    .help-fab:hover { transform: translateY(-2px) scale(1.04); }
    .help-fab--hidden { opacity: 0; pointer-events: none; }
    .help-fab__mark { font-size: 1.5rem; font-weight: 700; line-height: 1; }
  `],
})
export class HelpButtonComponent {
  @Input({ required: true }) system!: HelpSystemBase;
}
